<section>
	<div fxLayout.gt-md="row" fxLayoutGap="0px" fxLayoutGap.gt-md="20px">
		<div class="design-service-info" fxFlex.gt-md="50%">
			<h3 i18n="@@DesignServiceTitle">Send your wishes to our designers</h3>
			<p i18n="@@DesignServiceDescription"
				>We need some basic information to proceed with your design. Use the form on this page to submit
				them. You will receive a draft for your approval in 2-4 days. After you have approved the draft,
				the product is printed and delivered according to standard delivery times.</p
			>
			@if (viewport.isMediumOrLarger$ | async) {
				<g-product-additional-info [product]="product" />
			}
		</div>
		<aside fxFlex.gt-md="50%">
			@if (form) {
				<form [formGroup]="form" class="design-service-form">
					<div class="form-group">
						<label>
							<span i18n="@@DesignServiceFormLabelBasicInfo">Basic information and desired look</span
							><span class="required">*</span>
						</label>
						<p i18n="@@DesignServiceFormDescriptionBasicInfo"
							>Describe for example the use case, target group and company business. Also describe e.g.
							colors to be used and wishes for illustrations or photos.</p
						>
						<div class="form-group">
							<textarea formControlName="description" class="form-control"></textarea>
						</div>
						<div class="validation-error">
							{{ formErrors$ | async | validationField: 'description' }}
						</div>
					</div>
					<div class="form-group">
						<label>
							<span i18n="@@DesignServiceFormLabelEmail"
								>Email address where the draft will be delivered</span
							><span class="required">*</span>
						</label>
						<div class="form-group">
							<input type="email" formControlName="email" class="form-control" />
						</div>
						<div class="validation-error">
							{{ formErrors$ | async | validationField: 'email' }}
						</div>
					</div>
					<div class="form-group">
						<label i18n="@@DesignServiceFormLabelAttachments">File attachments</label>
						<p i18n="@@DesignServiceFormDescriptionAttachments"
							>Attach any logos, pictures, text documents, design guidelines or other content.</p
						>
						<g-upload
							[uploadedFiles]="uploadedFiles"
							[acceptedFiletypes]="acceptedFileTypes"
							fileType="PRINTFILE"
							[multiple]="true"
							(onUploadComplete)="onUploadSuccess()"
							(onUploadStart)="onUploadStart($event)"
							(onClear)="resetUploadSettings()"
							(onFiletypeError)="onFiletypeError()"
						/>
					</div>
				</form>
			}
			<div class="notification" [ngClass]="getNotificationStyleClass()">
				@switch (notification) {
					@case (notificationType.Warning) {
						<section>
							@if (isUploading$ | async) {
								<div class="heading" i18n="@@UploadInProgress">Uploading file...</div>
							}
						</section>
					}

					@case (notificationType.Danger) {
						<section>
							@if (isUploadError$ | async) {
								<div class="heading" i18n="@@UploadFailed">File could not be uploaded.</div>
							}
						</section>
					}

					@case (notificationType.Success) {
						<section class="heading">
							<span i18n="@@UploadSuccess">File uploaded successfully!</span>
						</section>
					}
				}

				@if (isFiletypeError) {
					<section class="heading">
						<p i18n="@@DesignServiceInvalidFileType">Invalid file type!</p>
						<p i18n="@@DesignServiceAllowedFileTypesAre">The allowed file types are:</p>
						<ul>
							<li i18n="@@DesignServiceFileTypeZip">Compressed file (ZIP)</li>
							<li i18n="@@DesignServiceFileTypeWord">Word document (DOC, DOCX)</li>
							<li i18n="@@DesignServiceFileTypeExcel">Excel document (CSV, XLS, XLSX)</li>
							<li i18n="@@DesignServiceFileTypePowerpoint">Powerpoint document (PPT, PPTX)</li>
							<li i18n="@@DesignServiceFileTypeText">Text file (TXT, RTF)</li>
							<li i18n="@@DesignServiceFileTypeJpeg">JPEG image</li>
							<li i18n="@@DesignServiceFileTypePng">PNG image</li>
							<li i18n="@@DesignServiceFileTypeZip">TIFF image</li>
							<li i18n="@@DesignServiceFileTypeSvg">SVG image</li>
							<li i18n="@@DesignServiceFileTypePdf">Adobe PDF</li>
							<li i18n="@@DesignServiceFileTypePhotoshop">Adobe Photoshop (PSD)</li>
							<li i18n="@@DesignServiceFileTypeIllustrator">Adobe Illustrator (AI)</li>
							<li i18n="@@DesignServiceFileTypeInDesign">Adobe InDesign (INDD, IDML)</li>
							<li i18n="@@DesignServiceFileTypePostScript">PostScript (PS, EPS)</li>
						</ul>
					</section>
				}
			</div>
		</aside>
		@if (viewport.isSmallOrExtraSmall$ | async) {
			<div>
				<hr />
				<g-product-additional-info [product]="product" />
			</div>
		}
	</div>
</section>
